<script>
export default {};
</script>

<template>
    <div class="header_container">
        <h1 class="page_title">Системные настройки</h1>
        <p class="page_description">
            Настройки работы поиска. Изменения сразу действуют для всех пользователей.
        </p>
    </div>
</template>

<style scoped>
.header_container {
    padding: 20px;
    padding-bottom: 10px;
}

.page_title {
    font-size: 24px;
    font-weight: 600;
    margin: 0 0 10px 0;
    color: var(--text-primary);
}

.page_description {
    font-size: 14px;
    color: var(--text-secondary);
    margin: 0;
}
</style>
